export default "__VITE_ASSET__D9HJWT3u__"